import styled, { theme } from 'academy-common-lib/utils/Styling';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import UICheckbox from 'UIComponents/input/UICheckbox';
import { useSearchParams } from '../../../utils/searchParams';
import LanguageNames from 'ui-addon-i18n/constants/LanguageNames';
import { useClearFilter, useToggleFilter, useSetFilter } from '../publicCatalogFiltersHooks';
import { jsx as _jsx } from "react/jsx-runtime";
const FilterOption = styled(UIButton).withConfig({
  displayName: "PublicCatalogMobileFilterOption__FilterOption",
  componentId: "sc-1tl41bg-0"
})(["width:100%;&:not(:last-child){border-bottom:1px solid ", " !important;}"], theme.colors.GREAT_WHITE);
const PublicCatalogMobileFilterOption = ({
  filterName,
  option
}) => {
  const [searchParams] = useSearchParams();
  const clearFilter = useClearFilter();
  const toggleFilter = useToggleFilter();
  const setFilter = useSetFilter();
  const currentlySelectedFilterOptions = searchParams[filterName] || [];
  // language may not have multiple values so only take the last one
  const validSelectedOptions = filterName === 'language' ? currentlySelectedFilterOptions.slice(-1) : currentlySelectedFilterOptions;
  const isOptionSelected = option === 'ALL' && validSelectedOptions.length === 0 || validSelectedOptions.includes(option);
  const handleOptionClick = () => {
    if (option === 'ALL') {
      clearFilter(filterName);
      return;
    }
    if (filterName === 'language') {
      setFilter(filterName, option);
      return;
    }
    toggleFilter(filterName, option);
  };
  return /*#__PURE__*/_jsx(FilterOption, {
    className: "m-left-0 p-right-5 p-y-2",
    onClick: handleOptionClick,
    use: "unstyled",
    children: /*#__PURE__*/_jsx(UICheckbox, {
      checked: isOptionSelected
      // @ts-expect-error onClick is not a valid prop for UICheckbox but required to prevent a double click event from being triggered
      ,
      onClick: event => {
        event.preventDefault();
      },
      tabIndex: -1,
      children: filterName === 'language' ? LanguageNames[option] : /*#__PURE__*/_jsx(FormattedMessage, {
        message: `academyPublic.catalogPage.filters.${filterName}.options.${option}`
      })
    })
  }, option);
};
export default PublicCatalogMobileFilterOption;